import { Component } from "react";
import RisksAndPreventionsListTab from "./RisksAndPreventionsListTab";
import SearchTab from "./SearchTab";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import SwipeableViews from "react-swipeable-views";
import { Link } from "react-router-dom";
import Fab from "@mui/material/Fab";
import Icon from "@mui/material/Icon/Icon";
import FooterFixedOnScreen from "../Layout/FooterFixedOnScreen";
import AppBar from "@mui/material/AppBar";
import HistoryIcon from "@mui/icons-material/History";
import withAuth from "../../components/withAuth";
import { compose } from "redux";
import { connect } from "react-redux";
import {
    setEditionState,
    initSppStatus,
    fillSimplifiedPreventionPlans,
    setModule,
} from "../../redux/analyseRisques/analyseRisquesActions";
import { redirectToLastVisualizedArOrPps } from "../../redux/analyseRisques/analyseRisquesActions";

class SimplifiedPreventionPlans extends Component {
    constructor(props) {
        super(props);
        this.props.fillSimplifiedPreventionPlans(this.props.analysesRisques);
        this.props.setModule(true);
        this.state = {
            selectedTab: 0,
        };
    }

    handleChange = (event, value) => {
        this.setState({ selectedTab: value });
    };

    handleChangeIndex = (index) => {
        this.setState({ selectedTab: index });
    };

    continuePps() {
        this.props.redirectToLastVisualizedArOrPps(true);
    }

    onCreateClick() {
        this.props.setEditionState(true, false);

        if (this.props.analysesRisques.moduleSpp) this.props.initSppStatus(this.props.analyseRisques.header);
    }

    render() {
        let tabs = [<Tab key={0} label="Liste" />, <Tab key={1} label="Recherche" />];

        let urlCreate;

        if (this.props.analysesRisques.moduleSpp) urlCreate = "/pps/createPps";
        else urlCreate = "/analyseRisques/createAnalyseRisques";

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding margin-top">
                <AppBar position="static" color="default">
                    <Tabs
                        value={this.state.selectedTab}
                        variant="scrollable"
                        scrollButtons="auto"
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        {tabs}
                    </Tabs>
                </AppBar>
                <SwipeableViews
                    axis="x"
                    index={this.state.selectedTab}
                    onChangeIndex={this.handleChangeIndex}
                    className="margin-top container-with-footer"
                >
                    <RisksAndPreventionsListTab />
                    <SearchTab />
                </SwipeableViews>
                <FooterFixedOnScreen>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 row">
                        <div className="col-lg-3 col-md-4 col-sm-6 col-6">
                            <Fab className="div-center green-button" onClick={this.continuePps.bind(this)}>
                                <HistoryIcon />
                            </Fab>
                            <span className="floating-btn-text span-center">Reprendre</span>
                        </div>
                        <div className="offset-lg-6 col-lg-3 offset-md-4 col-md-4 col-sm-6 col-6">
                            <Fab
                                color="primary"
                                component={Link}
                                className="div-center"
                                to={urlCreate}
                                onClick={this.onCreateClick.bind(this)}
                            >
                                <Icon>add</Icon>
                            </Fab>
                            <span className="floating-btn-text span-center">Créer</span>
                        </div>
                    </div>
                </FooterFixedOnScreen>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        analysesRisques: state.analysesRisques,
        analyseRisques: state.analyseRisques,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setEditionState: (creationMode, updateMode) => dispatch(setEditionState(creationMode, updateMode)),
        redirectToLastVisualizedArOrPps: (pps) => dispatch(redirectToLastVisualizedArOrPps(pps)),
        fillSimplifiedPreventionPlans: (analysesRisquesState) =>
            dispatch(fillSimplifiedPreventionPlans(analysesRisquesState)),
        setModule: (moduleSpp) => dispatch(setModule(moduleSpp)),
        initSppStatus: (header) => dispatch(initSppStatus(header)),
    };
};

export default compose(withAuth, connect(mapStateToProps, mapDispatchToProps))(SimplifiedPreventionPlans);
